import {  
    getFirestore, 
    query,
    collection,
    getDocs,
    where
} from "firebase/firestore";
const getGroupList = async function(owner) {

    let db = getFirestore();
    let ref = collection(db, "wellness_groups");
    let itemQuery = query( 
        ref
    );
    if( owner ){
        itemQuery = query( 
            ref,
            where('owner', '==', owner)
        );
    }
    const docSnap = (await getDocs(itemQuery));
    const itemList = [];
    if( docSnap.size ){
        docSnap.forEach( async (doc) => {
            itemList.push({
                text: doc.data().name + ' (' + doc.id + ')',
                value: doc.id
            });
        });
    }

    return itemList;
};
export default getGroupList;